import React from 'react';

const Logo = ({ data }) => {
  // If no gallery data, don't render the section
  if (!data || !Array.isArray(data) || data.length === 0) {
    return null;
  }

  return (
    <section className="logos_section py-5 pb_80">
      <div className="container overflow-hidden">
        <div className="marquee-wrapper">
          <div className="marquee-content">
            {/* First set of logos from what_we_do gallery */}
            {data.map((logo, index) => (
              <div className="item" key={index}>
                <img 
                  src={logo}
                  alt={`Logo ${index + 1}`} 
                  className="img-fluid mb-3"
                  onError={(e) => {
                    e.target.src = "https://via.placeholder.com/150x100?text=Logo";
                  }}
                  // style={{ maxHeight: '80px', objectFit: 'contain' }}
                />
              </div>
            ))}

            {/* Duplicate set for seamless infinite loop */}
            {data.map((logo, index) => (
              <div className="item" key={`duplicate-${index}`}>
                <img 
                  src={logo}
                  alt={`Logo ${index + 1}`} 
                  className="img-fluid mb-3"
                  onError={(e) => {
                    e.target.src = "https://via.placeholder.com/150x100?text=Logo";
                  }}
                  // style={{ maxHeight: '120px', objectFit: 'cover' }}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Logo;